<template>
  <div class="default-section">
    <h2 class="animation-item animation-top">{{header}}</h2>
    <div class="default-section__inner cia-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'default-section',
  props: ['header'],
};
</script>

<style lang="scss" scoped>
  .default-section {
    padding-bottom: 60px;
    @media (min-width: 550px) {
      padding-bottom: 60px;
    }
    @media (min-width: 1260px) {
      padding-bottom: 120px;
    }
    h2 {
      text-align: center;
      font-weight: 300;
      font-size: 26px;
      padding-bottom: 20px;
      @media (min-width: 550px) {
        font-size: 34px;
      }
      @media (min-width: 1000px) {
        font-size: 44px;
        padding-bottom: 50px;
      }
    }
  }
</style>
